import Registration from './Registration';
import RegistrationHOC from './RegistrationHOC';

export default RegistrationHOC(Registration);



// WEBPACK FOOTER //
// ./src/pages/Registration/index.jsx